package com.iptvplayer.shared.data.local.preferences

import com.iptvplayer.shared.domain.model.AuthToken
import com.iptvplayer.shared.domain.model.User
import kotlinx.browser.localStorage

actual class TokenStorage {

    actual fun saveToken(token: AuthToken) {
        localStorage.setItem(KEY_ACCESS_TOKEN, token.accessToken)
        localStorage.setItem(KEY_REFRESH_TOKEN, token.refreshToken)
        localStorage.setItem(KEY_EXPIRES_AT, token.expiresAt.toString())
    }

    actual fun getToken(): AuthToken? {
        val accessToken = localStorage.getItem(KEY_ACCESS_TOKEN) ?: return null
        val refreshToken = localStorage.getItem(KEY_REFRESH_TOKEN) ?: return null
        val expiresAt = localStorage.getItem(KEY_EXPIRES_AT)?.toLongOrNull() ?: return null
        return AuthToken(accessToken, refreshToken, expiresAt)
    }

    actual fun saveUser(user: User) {
        localStorage.setItem(KEY_USER_ID, user.id)
        localStorage.setItem(KEY_USER_NAME, user.username)
        localStorage.setItem(KEY_USER_EMAIL, user.email)
        localStorage.setItem(KEY_USER_CREATED_AT, user.createdAt.toString())
    }

    actual fun getUser(): User? {
        val id = localStorage.getItem(KEY_USER_ID) ?: return null
        val username = localStorage.getItem(KEY_USER_NAME) ?: return null
        val email = localStorage.getItem(KEY_USER_EMAIL) ?: return null
        val createdAt = localStorage.getItem(KEY_USER_CREATED_AT)?.toLongOrNull() ?: return null
        return User(id, username, email, createdAt)
    }

    actual fun saveDeviceId(deviceId: String) {
        localStorage.setItem(KEY_DEVICE_ID, deviceId)
    }

    actual fun getDeviceId(): String? =
        localStorage.getItem(KEY_DEVICE_ID)

    actual fun clear() {
        listOf(
            KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN, KEY_EXPIRES_AT,
            KEY_USER_ID, KEY_USER_NAME, KEY_USER_EMAIL, KEY_USER_CREATED_AT,
            KEY_DEVICE_ID
        ).forEach { localStorage.removeItem(it) }
    }

    private companion object {
        const val KEY_ACCESS_TOKEN = "access_token"
        const val KEY_REFRESH_TOKEN = "refresh_token"
        const val KEY_EXPIRES_AT = "expires_at"
        const val KEY_USER_ID = "user_id"
        const val KEY_USER_NAME = "user_name"
        const val KEY_USER_EMAIL = "user_email"
        const val KEY_USER_CREATED_AT = "user_created_at"
        const val KEY_DEVICE_ID = "device_id"
    }
}
